import { render, staticRenderFns } from "./ListEditBlock.vue?vue&type=template&id=2c68fdf3&scoped=true&"
import script from "./ListEditBlock.vue?vue&type=script&lang=js&"
export * from "./ListEditBlock.vue?vue&type=script&lang=js&"
import style0 from "./ListEditBlock.vue?vue&type=style&index=0&id=2c68fdf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68fdf3",
  null
  
)

export default component.exports